<template>
    <div id="casino-mobile-widget" />
</template>

<script setup lang="ts">
    import { useScriptTag } from '@vueuse/core';
    import { getCasinoWidgetUrl } from '@/libraries/url';
    import { useWidgetStore } from '@/stores/widgetStore';

    const { preregisterWidget, unregisterWidget } = useWidgetStore();
    preregisterWidget('casino');

    const { load } = useScriptTag(`${getCasinoWidgetUrl()}/mobile-widget.js`, undefined, { manual: true });
    load().catch(() => {
        unregisterWidget('casino');
    });
</script>
